<template>
  <svg width="25" height="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.6014 10.7538C20.6014 16.1828 16.2004 20.5838 10.7714 20.5838C5.34245 20.5838 0.941406 16.1828 0.941406 10.7538C0.941406 5.32487 5.34245 0.923828 10.7714 0.923828C16.2004 0.923828 20.6014 5.32487 20.6014 10.7538Z" fill="white" stroke="#0ACF97" stroke-width="0.5"/>
<path d="M14.7281 10.0473C14.895 10.0473 15.0362 10.1051 15.1518 10.2207C15.2802 10.3362 15.3444 10.4775 15.3444 10.6444C15.3444 10.8113 15.2866 10.9589 15.1711 11.0873C15.0555 11.2029 14.9079 11.2606 14.7281 11.2606H11.2423V14.7271C11.2423 14.9069 11.1846 15.0545 11.069 15.1701C10.9535 15.2856 10.8122 15.3434 10.6453 15.3434C10.4784 15.3434 10.3372 15.2856 10.2217 15.1701C10.1061 15.0417 10.0483 14.894 10.0483 14.7271V11.2606H6.56256C6.39565 11.2606 6.248 11.2029 6.11961 11.0873C6.00406 10.9589 5.94629 10.8113 5.94629 10.6444C5.94629 10.4775 6.00406 10.3362 6.11961 10.2207C6.248 10.1051 6.39565 10.0473 6.56256 10.0473H10.0483V6.58084C10.0483 6.40109 10.1061 6.25345 10.2217 6.1379C10.3372 6.00951 10.4784 5.94531 10.6453 5.94531C10.8122 5.94531 10.9535 6.00951 11.069 6.1379C11.1846 6.25345 11.2423 6.40109 11.2423 6.58084V10.0473H14.7281Z" fill="#0ACF97"/>
</svg>

</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    path {
        transition: all 0.2s ease;
    }
    &:hover {
        path {
            &:first-child {
                stroke: #ffffff;
                fill: #0ACF97;
            }
            &:last-child {
                fill: #ffffff;
            }
        }
    }
}
</style>